import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import mixpanelEvents from '@Mixpanel';
import { setSortFlags } from '@Actions/filterActions';
import { RadioMultiSelectDropdown } from '@Components/UI/Dropdowns';
import { FilterDiv, InBodyTitle } from '../ScoreCardFilters.style';

const Sorting = () => {
    const dispatch = useDispatch();

    const SortFlagsInput = useSelector(state => state.scoreCardFilters.SortFlagsInput);

    return (
        <FilterDiv>
            <InBodyTitle>Sorting</InBodyTitle>
            <RadioMultiSelectDropdown
                id={`sorting_${4}`}
                name="sorting"
                options={SortFlagsInput}
                setOptions={input => {
                    dispatch(setSortFlags(input));
                    mixpanelEvents.scorecardFiltersApplied();
                }}
            />
        </FilterDiv>
    );
};

export default Sorting;
